// src/config.js - UPDATE THIS FILE
const BASE_URL = "https://dvrinstitute.com";
console.log("🔧 Config loaded - BASE_URL:", BASE_URL); // Add this for debugging
export default BASE_URL;